import { Phone, MapPin, Mail } from "lucide-react";

export default function Footer() {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer" className="bg-[#051F16] border-t border-[#1D4133]/50 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="font-['Playfair_Display'] text-2xl font-semibold text-[#F0FDF4] tracking-tight mb-4">
              Veranda <span className="text-[#EAB308]">pod Soutokem</span>
            </h3>
            <p className="text-sm text-[#94A3B8] leading-relaxed">
              Poctivá česko-ukrajinská kuchyně v srdečné atmosféře.
              Obědy přes den, večeře a posezení večer.
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-semibold text-[#F0FDF4] mb-4 uppercase tracking-wider text-sm">Navigace</h4>
            <div className="space-y-2">
              {[
                { label: "O nás", href: "#about" },
                { label: "Galerie", href: "#gallery" },
                { label: "Snídaně", href: "#breakfast-menu" },
                { label: "Stálé menu", href: "#evening-menu" },
                { label: "Polední menu", href: "#lunch-menu" },
                { label: "Kontakt", href: "#contact" },
              ].map((link) => (
                <button
                  key={link.href}
                  onClick={() => scrollTo(link.href)}
                  className="block text-sm text-[#94A3B8] hover:text-[#EAB308] transition-colors"
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-[#F0FDF4] mb-4 uppercase tracking-wider text-sm">Kontakt</h4>
            <div className="space-y-3">
              <a
                href="tel:+420733513535"
                data-testid="phone-link-footer"
                className="flex items-center gap-2 text-[#EAB308] font-semibold hover:text-yellow-300 transition-colors"
              >
                <Phone className="w-4 h-4" />
                +420 733 513 535
              </a>
              <a
                href="mailto:veranda-melnik@seznam.cz"
                data-testid="email-link-footer"
                className="flex items-center gap-2 text-sm text-[#94A3B8] hover:text-[#EAB308] transition-colors"
              >
                <Mail className="w-4 h-4 flex-shrink-0" />
                veranda-melnik@seznam.cz
              </a>
              <div className="flex items-start gap-2 text-sm text-[#94A3B8]">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>Legionářů 84, 276 01 Mělník</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-[#1D4133]/50 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
            <p className="text-xs text-[#94A3B8]/60">
              {new Date().getFullYear()} Veranda pod Soutokem. Všechna práva vyhrazena.
            </p>
            <span className="hidden sm:inline text-[#94A3B8]/30">|</span>
            <p className="text-xs text-[#94A3B8]/40">IČO: 27865568</p>
          </div>
          <a
            href="/admin/login"
            className="text-xs text-[#94A3B8]/40 hover:text-[#94A3B8] transition-colors"
            data-testid="admin-link"
          >
            Administrace
          </a>
        </div>
      </div>
    </footer>
  );
}
